import { Text } from '@mantine/core'

/**
 * Section label used above content panels (CREW MANIFEST, DOCUMENTS, AI
 * FEEDBACK, etc.). These are Orbitron all-caps, which is the hardest case to
 * read small — so this centralizes the legibility treatment: a larger size
 * than the old `xs`, a heavier-but-not-cramped weight, and letter-spacing
 * (driven by the theme var so a theme can dial it per-aesthetic). Swapping the
 * scattered title sites to this one component means future tweaks are one edit.
 *
 * Defaults match the prior look (dimmed, uppercase) but bumped for readability.
 * Pass any Mantine Text prop to override (e.g. c="cyan.4").
 */
export function PanelTitle({ children, c = 'dimmed', ...props }) {
  return (
    <Text
      size="sm"
      fw={600}
      c={c}
      tt="uppercase"
      ff="var(--bw-heading-font)"
      style={{ letterSpacing: 'var(--bw-heading-letter-spacing, 0.05em)' }}
      {...props}
    >
      {children}
    </Text>
  )
}
